import React from "react"

import {FieldManagementFormProps} from "../../../../render/management-form"
import FormManager from "../../../../../gd-form/common/form-manager"
import ErrorBoundary from "../../../../../error-boundary"
import FieldManagementLeftPanel from "../../../../proto/render/management/panel/form-left-panel"
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import ButtonSubmitDeprecated from "../../../../../gd-form/common/btn-submit/btn-submit-ui5"
import CustomField_FromRowScope from "../../../../../fields/custom/common/form-scope"
import {FieldManagementFormCFV1Props} from "../../../../render/management-form-cf-v1"
import {CustomFieldScope} from "../../../../../model2/custom-field/@const"
import CustomFieldName from "../../../../../fields/custom/common/form-name"
import CustomFieldDisplayName from "../../../../../fields/custom/common/form-display-name"
import CustomFieldAccess from "../../../../../fields/custom/common/form-access"


// const debug = "FieldSkills_ManagementFormCFV1"
const debug = false

export default class FieldSkills_ManagementFormCFV1 extends React.Component<FieldManagementFormCFV1Props> {

    public form         : FormManager

    constructor(props:FieldManagementFormProps) {
        super(props)

        const initFormData = {
            name        : this.props.field.label || '',
            displayName : this.props.field.fieldParams.displayName,
            description : _.get(this.props, 'field.description', ''),
            access      : _.get(this.props, 'field.fieldAccess', gd.const.customFields.access.EVERYONE),
            scope       : this.props.field.fieldParams.scope || [CustomFieldScope.TASK],
            options     : this.props.field.options
        }

        const formStructure = {
            fields: {
                name       : {
                    type: 'input',
                    isRequired: true,
                    label: 'Label',
                    validator: (val:any) => {
                        let res:any = true;
                        if (val === null || val === undefined || val.trim() === '') {
                            res = 'Invalid label';
                        }
                        return res;
                    },
                    onUserChange: this.onLabelChange
                },
                displayName       : {
                    type        : 'input',
                    isRequired  : false,
                    label       : 'Display label',
                },
                access : { type: 'select',     isRequired: true,   label: 'Access'},

                scope       : {
                    type        : 'input',
                    isRequired  : true
                },
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure, initFormData)
    }

    onLabelChange = () => {
        this.forceUpdate()
    }

    onSubmit = (result:any) => {

        debug && console.log(debug, 'onSubmit', result)

        this.props.field.label          = result.name.trim()
        this.props.field.fieldAccess    = result.access

        this.props.field.fieldParams    = {
            displayName : result.displayName?.trim(),
            scope       : result.scope,
        }

        this.props.field.options = result.options;

        debug && console.log(debug, 'onSubmit field', this.props.field)

        // props.field is an object so we never return anything in here
        this.props.onSubmit(this.props.field)
    }

    render() {
        return (
            <>
                <ErrorBoundary>
                    <FieldManagementLeftPanel field={this.props.field} />
                </ErrorBoundary>

                <ErrorBoundary>
                    <div className="iv-cf-form">
                        <VScroll className="iv-cf-scroll">
                            <div className="iv-header header-left header-small-no-separator">
                                <div className="title-line">
                                    <div className="view-name">
                                        <div className="ui5-title-app-name max-w-350 ">New Custom Field</div>
                                    </div>
                                </div>
                            </div>

                            <div className="iv-content with-left-panel">
                                <div className="p-l-30">
                                    <div className="ui5-form size-30-70">
                                        <div className="f-tbl">
                                            <CustomFieldName form={this.form}/>
                                            <CustomFieldDisplayName form={this.form}/>
                                            <CustomFieldAccess form={this.form}/>

                                            <CustomField_FromRowScope form={this.form}
                                                                      mandatoryScope={this.props.mandatoryScope || []}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </VScroll>

                        <div className="bottom-action">
                            <ButtonSubmitDeprecated form={this.form} className="submit" label="Save"/>
                        </div>
                    </div>
                </ErrorBoundary>
            </>
        )
    }
}
